import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './xian@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="experiential-education">
    <h1>體育</h1>
    <p>
      在京斯敦，我們確保學生有大量機會參與本港及海外的體驗學習。老師計劃單元課教案時，會加入引導學生提出疑問的元素，並透過直接觀察進行探究。
    </p>
    <h3>宿營之旅</h3>
    <p>
      學生在五年級時，會參加三天兩夜的戶外教育營，目的是建立彼此間的團隊合作精神。我們與香港的戶外教育機構合作，確保宿營之旅由合資格領隊帶領，為學生提供優質的宿營體驗。
    </p>

    <h3>海外考察</h3>
    <p>
      京斯敦過去十多年皆安排六年級學生參加五天四夜的海外考察。過去的考察地點十分多元化，包括西安、泰國、新加坡、汶萊及北京。每年的考察都會融合六年級的探究單元，圍繞單元的中心思想詳細計劃以提升學習經驗。海外考察同時能訓練學生的獨立性，在家以外建立責任感。
    </p>

    <img src={image} alt="Xi'an Terracotta Army" />
  </ContentLayout>
);
